import { render, staticRenderFns } from "./createQZtools.vue?vue&type=template&id=2eb628be&scoped=true"
import script from "./createQZtools.vue?vue&type=script&lang=js"
export * from "./createQZtools.vue?vue&type=script&lang=js"
import style0 from "./createQZtools.vue?vue&type=style&index=0&id=2eb628be&prod&lang=css"
import style1 from "./createQZtools.vue?vue&type=style&index=1&id=2eb628be&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb628be",
  null
  
)

export default component.exports